import {Component, Input, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {ModalController} from "@ionic/angular";

@Component({
  selector: 'app-header-toolbar-modal-location',
  templateUrl: './header-toolbar-modal-location.component.html',
  styleUrls: ['./header-toolbar-modal-location.component.scss'],
})
export class HeaderToolbarModalLocationComponent implements OnInit {

  city: string = "n1";
  @Input() title:string;
  constructor(private route: Router, private modalController: ModalController) {}

  ngOnInit() {}
  dismiss(){
    this.modalController.dismiss();
  }
}
